import { TouchpointType } from "types/touchpoint";

import Icons, { type SVGIconProps } from "assets";

interface TouchpointIconProps extends SVGIconProps {
  touchpointType: TouchpointType;
}

const TouchpointIcon = ({ touchpointType, ...rest }: TouchpointIconProps) => {
  if (touchpointType === TouchpointType.EMAIL) {
    return <Icons.Email {...rest} />;
  }
  if (touchpointType === TouchpointType.OTHER) {
    return <Icons.Other {...rest} />;
  }
  return <Icons.LandingPage {...rest} />;
};

export default TouchpointIcon;
